export * from 'js/components/system/Portlet/helpers';

export const getPortletCSSClassNames = (portletConfig) => {
    const { showTitle, portletType, customCSSClassName = '' } = portletConfig;
    const classList = [
        'fn-portlet',
        'portlet__content',
        `portlet__content_border_${showTitle ? 'show' : 'none'}`,
        portletType ? `portlet__content_type_${portletType}` : '',
        customCSSClassName
    ];

    return classList.join(' ');
};
